export default import.meta.ROLLDOWN_FILE_URL_dLts65K88X0Og7JWtThTXA